



































































































































































































































import { CapaDaNota, FiltroDeCapaDaNota, TipoDaNota } from '@/models'
import { DataOptions } from 'vuetify'
import { Vue, Component, Watch, Ref } from 'vue-property-decorator'
import SeletorDeLojasDoUsuario from '@/components/loja/SeletorDeLojasDoUsuario.vue'
import DatePicker from '@/components/ui/DatePicker.vue'
import RangeDatePicker from '@/components/ui/RangeDatePicker.vue'
import { backendDomain, nextTick } from '@/shareds/utils'
import { DownloadNotasUseCase, FindCapaDaNotaUseCase, EmailUseCase, FindImportacaoUseCase } from '@/usecases'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { sortConverter } from '@/shareds/paginacao'
import moment from 'moment'
import { formatarCnpjOuCpf } from '@/shareds/formatadores'
import { descricaoDoStatusSefaz } from '@/shareds/fiscal/status-da-nota'
import { dateTimeToPtBrFormat } from '@/shareds/date/date-utils'
import { AmbienteFiscal } from '@/models/SerieFiscal'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import { serializarQueryString } from '@/common/request'
import { obrigatorio, emailInvalido } from '@/shareds/regras-de-form'
import JSZip from 'jszip'
import axios, { CancelTokenSource } from 'axios'

const FILTRO_DE_NOTAS = 'FILTRO_DE_NOTAS'
const LIMITE_DE_DIAS_DO_PERIODO = 31

function periodoPadrao(): (string | null)[] {
	return [
		moment().startOf('month').format('YYYY-MM-DD'),
		moment().format('YYYY-MM-DD'),
	]
}

// o calendário em modo range devolve as datas na ordem em que foram clicadas
function ordenarPeriodo(datas: (string | null)[] | null | undefined): (string | null)[] {
	const [inicio, fim] = ((datas || []).filter(Boolean) as string[]).sort()
	return [inicio || null, fim || null]
}

function carregarFiltroSalvo(): FiltroDaNota | null {
	if (!localStorage[FILTRO_DE_NOTAS]) return null
	try {
		const salvo = JSON.parse(localStorage[FILTRO_DE_NOTAS])
		if (!Array.isArray(salvo.datas)) {
			// filtros salvos antes do período livre guardavam só o mês
			salvo.datas = salvo.mesReferencia
				? [
					moment(salvo.mesReferencia, 'YYYY-MM').startOf('month').format('YYYY-MM-DD'),
					moment(salvo.mesReferencia, 'YYYY-MM').endOf('month').format('YYYY-MM-DD'),
				]
				: periodoPadrao()
			delete salvo.mesReferencia
		}
		return salvo
	} catch (e) {
		return null
	}
}

@Component({
	components:{
		SeletorDeLojasDoUsuario,
		DatePicker,
		RangeDatePicker,
	},
})
export default class TelaDeDocumentosFiscais extends Vue {

	@Ref() form!: HTMLFormElement
	@Ref() formEmail!: HTMLFormElement

	headers = [
		{ text: 'Data de Emissão', value: 'displayDataEntradaEmissao', sortable: false  },
		{ text: 'Emitente', value: 'xNomeEmit', sortable: false },
		{ text: 'Destinatário', value: 'xNomeDest', sortable: false},
		{ text: 'Nf/Série', value: 'displayNfSerie', sortable: false },
		{ text: 'Status', value: 'displayStatusDaNota', sortable: false },
		{ text: 'E/S', value: 'displayEntradaOuSaida', sortable: false },
		{ text: 'R$ Valor', value: 'displayValor', sortable: false},
	]

	buscando = false
	capaDaNota: CapaDaNota[] = []
	dialogoEnvioEmailAberto = false
	emailDestino = ''
	enviandoXmls = false

	findUseCase = new FindCapaDaNotaUseCase()
	downloadNotasUseCase = new DownloadNotasUseCase()
	emailUseCase = new EmailUseCase()
	findImportacaoUseCase = new FindImportacaoUseCase
	
	cancelToken: CancelTokenSource | null = null
	baixandoXmlsCompletos = false
	podeGerarDownloadCompleto = true

	obrigatorio = obrigatorio

	emailInvalido = emailInvalido	

	LIMITE_DE_DIAS_DO_PERIODO = LIMITE_DE_DIAS_DO_PERIODO

	filtro: FiltroDaNota = carregarFiltroSalvo()
		|| {
			busca:'',
			lojaId: null,
			datas: periodoPadrao(),
			serieFiscal: '',
			ambientes: ["Produção"],
			notaInicial: null,
			notaFinal: null,
			tpnf: null,
			exibirSomenteNotasValidas: false,
			somenteCompras:false,
			page: 0,
			size: 0,
			sort: 'createdAt,desc',
		}
	totalRegistros = -1

	paginacao: DataOptions = {
		page: 0,
		itemsPerPage: 10,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}

	aplicarFiltros() {
		this.paginacao = {
			...this.paginacao,
			page: 1,
		}
	}

	get periodoOrdenado(): (string | null)[] {
		return ordenarPeriodo(this.filtro.datas)
	}

	periodoDentroDoLimite = () => {
		const [inicio, fim] = this.periodoOrdenado
		if (!inicio || !fim) return true
		return moment(fim).diff(moment(inicio), 'days') < LIMITE_DE_DIAS_DO_PERIODO
			|| `O período não pode passar de ${LIMITE_DE_DIAS_DO_PERIODO} dias`
	}

	// com a primeira data escolhida no calendário, só libera as que cabem no limite
	dataPermitidaNoPeriodo = (data: string) => {
		const datas = this.filtro.datas || []
		if (datas.length !== 1 || !datas[0]) return true
		return Math.abs(moment(data).diff(moment(datas[0]), 'days')) < LIMITE_DE_DIAS_DO_PERIODO
	}

	normalizarFiltros(filtro: FiltroDaNota): FiltroDeCapaDaNota {
		const [inicio, fim] = ordenarPeriodo(filtro.datas)
		const dataInicial = inicio
			? moment(inicio, 'YYYY-MM-DD').startOf('day').toISOString(true)
			: undefined
		const dataFinal = fim
			? moment(fim, 'YYYY-MM-DD').endOf('day').toISOString(true)
			: undefined
		const sorted = sortConverter(this.paginacao)
		return {
			dataInicial,
			dataFinal,
			lojaId: this.filtro.lojaId || undefined,
			serie: this.filtro.serieFiscal || undefined,
			ambientes: this.filtro.ambientes || undefined,
			notaInicial: this.filtro.notaInicial || undefined,
			notaFinal: this.filtro.notaFinal || undefined,
			tpnf: this.filtro.tpnf || undefined,
			exibirSomenteNotasValidas: this.filtro.exibirSomenteNotasValidas || undefined,
			somenteCompras: this.filtro.somenteCompras || undefined,
			somenteNotasAprovadas: this.filtro.somenteNotasAprovadas || undefined,
			page: this.paginacao.page -1,
			size: this.paginacao.itemsPerPage,
			sort: !sorted.length ? ['dhEmi,desc'] : sorted,
		}
	}

	@Watch('paginacao')
	async buscar() {
		if (!this.form.validate()) return
		if (this.buscando) return
		await nextTick()

		if((this.filtro.notaInicial && !this.filtro.notaFinal) || (!this.filtro.notaInicial && this.filtro.notaFinal)){
			AlertModule.setError('Ao filtrar Notas Inicias e Notas finais, ambos campos devem ser preenchidos!');
			return
		} 

		this.cancelToken = axios.CancelToken.source()

		this.filtro.page = this.paginacao.page - 1
		this.filtro.size = this.paginacao.itemsPerPage
		this.filtro.sort = 'createdAt,desc'

		try {
			this.buscando = true
			const page = await this.findUseCase.find(this.normalizarFiltros(this.filtro))
			this.capaDaNota = page.content
			this.totalRegistros = page.totalElements

		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.buscando = false
		}
	}

	get usuario() {
		return UserLoginStore.usuario?.id
	}

	get permiteAbrirDiversosProcessosDeImportacao(){
		if(!UserLoginStore.perfil) return false
		return UserLoginStore.perfil.permissoes.includes('permite-abrir-diversos-processos')
	}


	async criarProcessoDeXmlsCompletos() {
		if (this.baixandoXmlsCompletos) return
		if(!this.usuario) return
		if (!this.form.validate()) return

		if(!this.permiteAbrirDiversosProcessosDeImportacao){
			const possuiProcessoEmAberto = await this.findImportacaoUseCase.possuiImportacoesEmAbertoNoUsuarioLogado(this.usuario);

			if(!possuiProcessoEmAberto){
				AlertModule.setError('Já existe um processo em aberto para o usuario, aguarde finalizar para prosseguir!');
				this.baixandoXmlsCompletos = false;
				return
			}
		}

		AlertModule.setSuccess("Processo gerado com sucesso! <br>Os Xml's devem ficar prontos para download em alguns minutos na tela de processos")
		try {
			this.baixandoXmlsCompletos = true
			const xmls = await this.downloadNotasUseCase.getXmlsCompletos(this.normalizarFiltros(this.filtro))
			this.downloadXmlAsZip(xmls, 'notas-fiscais-completas')
			await this.verificarSePodeGerarDownloadCompleto
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.baixandoXmlsCompletos = false
		}
	}

	async downloadXmlAsZip(xmlStrings, zipFileName) {
		const zip = new JSZip()

		xmlStrings.forEach((xmlString) => {
			const xmlStringSeparados = xmlString.split("&&&")

			const blob = new Blob([xmlStringSeparados[1]], { type: "application/xml" })
			const fileName = xmlStringSeparados[0]
			zip.file(fileName, blob)
		});

		const zipBlob = await zip.generateAsync({ type: "blob" })

		const url = URL.createObjectURL(zipBlob)
		const a = document.createElement("a")
		a.href = url
		a.download = zipFileName || ".zip"
		document.body.appendChild(a)
		a.click()
		document.body.removeChild(a)

		setTimeout(() => URL.revokeObjectURL(url), 1000)
	}

	limparFiltros() {
		this.filtro = {
			busca:'',
			lojaId: null,
			datas: periodoPadrao(),
			serieFiscal: '',
			ambientes: ["Produção"],
			notaInicial: '',
			notaFinal: '',
			tpnf: null,
			exibirSomenteNotasValidas: false,
			somenteCompras:false,
			page: 0,
			size: 0,
			sort: 'createdAt,desc',
		}
		this.capaDaNota = []
		this.form.resetValidation();
	}

	get itens() {
		return this.capaDaNota.map(capaDaNota => ({
			...capaDaNota,
			displayNfSerie: this.displayNfSerie(capaDaNota),
			displayCnpjEmitente: this.displayCnpj(capaDaNota.cnpjEmit),
			displayCnpjDestinatario: this.displayCnpj(capaDaNota.cnpjDest),
			displayStatusDaNota: this.displayStatusDaNota(capaDaNota),
			displayDataEntradaEmissao: this.displayDataEntradaEmissao(capaDaNota),
			displayEntradaOuSaida: this.displayEntradaOuSaida(capaDaNota),
			displayValor: capaDaNota ? this.displayValor(capaDaNota) : '0,00' ,
		}))
	}

	displayStatusDaNota(capaDaNota: CapaDaNota) {
		const nota = capaDaNota
		const descricao = nota && descricaoDoStatusSefaz(nota.codigoDeStatus, nota.inutilizacaoDispensada)
		return descricao
			? nota.codigoDeStatus + ' - ' + descricao
			: nota?.codigoDeStatus || ''
	}

	displayNfSerie (capaDaNota: CapaDaNota) {
		const nota = capaDaNota
		return nota
			? nota.serie
			: ''
	}

	displayCnpj(cnpj: string) {
		if(!cnpj) return ''
		return formatarCnpjOuCpf(cnpj)
	}

	displayDataEntradaEmissao(capaDaNota: CapaDaNota) {
		const dataHoraEntradaEmissao = capaDaNota.dhEmi
		return dateTimeToPtBrFormat(dataHoraEntradaEmissao)
	}

	displayEntradaOuSaida(capaDaNota: CapaDaNota) {
		return capaDaNota.tpNF == 0 ?  'Entrada' : 'Saída'
	}

	displayValor(capaDaNota: CapaDaNota) {
		return capaDaNota.vnf.replace('.',',')
	}

	@Watch('filtro', { deep: true })
	onChangeFiltro(newFiltro) {
		const stringified = JSON.stringify(newFiltro);
		localStorage.setItem(FILTRO_DE_NOTAS, stringified)
	}

	set atualizarFiltroTpnf(value: string) {
		if (value === 'Entrada') {
			this.filtro.tpnf = '0'
		} else if(value === 'Saída') {
			this.filtro.tpnf = '1'
			this.filtro.somenteCompras = false
		} else {
			this.filtro.tpnf = null
		}
	}

	get atualizarFiltroTpnf() {
		if (this.filtro.tpnf === '0') {
			return 'Entrada'
		} else if(this.filtro.tpnf === '1') {
			return 'Saída'
		} else {
			return 'Entrada e Saída'
		}
	}

	get urlDeRelatoriosDeEntradaDeNotasNfce() {
		if (!UserLoginStore.token) return ''
		const queryString = serializarQueryString({
			token: encodeURI(UserLoginStore.token),
			...this.normalizarFiltros(this.filtro),
		})
		return `${backendDomain()}/notas-fiscais/relacao-de-entradas/RelacaoDeEntradasDeNotasNfe.csv?${queryString}`
	}	

	@Watch('paginacao', { deep: true })
	onChangePaginacao = this.buscar	

	abrirDialogoEnvioEmail() {
		if (!this.form.validate()) return				
		return	this.dialogoEnvioEmailAberto = true;		
	}	

	enviarEmail() {		
		if (!this.formEmail.validate()) return		

		this.enviarXmlsPorEmail();

		setTimeout(() => {
			this.fecharDialogoEnvioEmail();
			AlertModule.setSuccess('XMLs enviados com sucesso!');
		}, 4000);  
	}

	fecharDialogoEnvioEmail() {
		this.dialogoEnvioEmailAberto = false		
		this.emailDestino = ''
	}	

	async enviarXmlsPorEmail() {		
		if (this.enviandoXmls) return				

		try {
			this.enviandoXmls = true;	

			await this.emailUseCase.enviarXmlsPorEmail(
				this.normalizarFiltros(this.filtro),
				this.emailDestino,								
			);			
			
		} catch (error) {
			AlertModule.setError('Falha ao enviar XMLs por e-mail.');
		} finally {
			this.enviandoXmls = false;
		}
	}

	async mounted() {
		this.verificarSePodeGerarDownloadCompleto();
	}

	@Watch('filtro.lojaId')
	onLojaIdChanged() {
		this.verificarSePodeGerarDownloadCompleto();
	}

	async verificarSePodeGerarDownloadCompleto() {
		
		this.cancelToken = axios.CancelToken.source()
		const lojaId = this.filtro.lojaId;
		if (!lojaId) return;

		try {
			
			const axiosConfig = {
				cancelToken: this.cancelToken.token,
			}

			this.podeGerarDownloadCompleto = await this.findImportacaoUseCase.podeGerarDownloadCompleto(lojaId, axiosConfig);
		} catch (e) {
			this.podeGerarDownloadCompleto = false;
		}

		if (!this.podeGerarDownloadCompleto) {
			AlertModule.setInfo(
				'Limite de 3 processos de XMLS Fiscais sendo executados no momento.<br>Aguarde um momento.',
			);
		}
	}
}

export interface FiltroDaNota {
	busca: string
	lojaId: string | null
	datas: (string | null)[]
	serieFiscal: string
	ambientes: AmbienteFiscal[]
	notaInicial: string | null
	notaFinal: string | null
	tpnf: TipoDaNota | null
	exibirSomenteNotasValidas: boolean
	somenteCompras?: boolean
	somenteNotasAprovadas?: boolean
	page: number
	size: number
	sort: string
}
